import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { Cancel } from "@mui/icons-material";

/**
 * Stop and Error Node — Parar execucao e lancar erro.
 *
 * data.errorMessage: string — mensagem de erro
 * data.errorCode: string — codigo de erro (ex: "INVALID_INPUT")
 * data.logError: boolean — registrar no log de execucao
 *
 * Sem saidas — este node encerra o fluxo.
 */
const StopErrorNode = memo(({ id, data, isConnectable, selected }) => {
  const errorMessage = data?.errorMessage || "";
  const errorCode = data?.errorCode || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Cancel />}
      title="Parar com Erro"
      color="#c62828"
      bgColor="#FFEBEE"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={200}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px", fontSize: 11,
      }}>
        {errorCode && (
          <div style={{
            fontFamily: "'Fira Code', monospace",
            color: "#c62828", fontWeight: 600, fontSize: 11,
          }}>
            [{errorCode}]
          </div>
        )}
        {errorMessage ? (
          <div style={{
            color: "#666", fontSize: 10, marginTop: 2,
            maxHeight: 32, overflow: "hidden", textOverflow: "ellipsis",
          }}>
            {errorMessage.substring(0, 60)}{errorMessage.length > 60 ? "..." : ""}
          </div>
        ) : (
          <div style={{ color: "#999", fontSize: 10, fontStyle: "italic" }}>
            Encerra o fluxo com erro
          </div>
        )}
      </div>
    </NodeWrapper>
  );
});

StopErrorNode.displayName = "StopErrorNode";
export default StopErrorNode;
